/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../../../../gen/eigen_lcm/Vector3d";

export const protobufPackage = "skills";

export interface SpoofTrackingDeviceActionArgs {
  durationS: number;
  initialPositionNav: Vector3dPb | undefined;
  velocityNav: Vector3dPb | undefined;
}

export interface SpoofTrackingDeviceResultData {
}

export interface SpoofTrackingDeviceActionStateData {
}

function createBaseSpoofTrackingDeviceActionArgs(): SpoofTrackingDeviceActionArgs {
  return { durationS: 0, initialPositionNav: undefined, velocityNav: undefined };
}

export const SpoofTrackingDeviceActionArgs = {
  encode(message: SpoofTrackingDeviceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.durationS !== 0) {
      writer.uint32(9).double(message.durationS);
    }
    if (message.initialPositionNav !== undefined) {
      Vector3dPb.encode(message.initialPositionNav, writer.uint32(18).fork()).ldelim();
    }
    if (message.velocityNav !== undefined) {
      Vector3dPb.encode(message.velocityNav, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofTrackingDeviceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofTrackingDeviceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.durationS = reader.double();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.initialPositionNav = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.velocityNav = Vector3dPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofTrackingDeviceActionArgs {
    return {
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
      initialPositionNav: isSet(object.initialPositionNav) ? Vector3dPb.fromJSON(object.initialPositionNav) : undefined,
      velocityNav: isSet(object.velocityNav) ? Vector3dPb.fromJSON(object.velocityNav) : undefined,
    };
  },

  toJSON(message: SpoofTrackingDeviceActionArgs): unknown {
    const obj: any = {};
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    if (message.initialPositionNav !== undefined) {
      obj.initialPositionNav = Vector3dPb.toJSON(message.initialPositionNav);
    }
    if (message.velocityNav !== undefined) {
      obj.velocityNav = Vector3dPb.toJSON(message.velocityNav);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofTrackingDeviceActionArgs>, I>>(base?: I): SpoofTrackingDeviceActionArgs {
    return SpoofTrackingDeviceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofTrackingDeviceActionArgs>, I>>(
    object: I,
  ): SpoofTrackingDeviceActionArgs {
    const message = createBaseSpoofTrackingDeviceActionArgs();
    message.durationS = object.durationS ?? 0;
    message.initialPositionNav = (object.initialPositionNav !== undefined && object.initialPositionNav !== null)
      ? Vector3dPb.fromPartial(object.initialPositionNav)
      : undefined;
    message.velocityNav = (object.velocityNav !== undefined && object.velocityNav !== null)
      ? Vector3dPb.fromPartial(object.velocityNav)
      : undefined;
    return message;
  },
};

function createBaseSpoofTrackingDeviceResultData(): SpoofTrackingDeviceResultData {
  return {};
}

export const SpoofTrackingDeviceResultData = {
  encode(_: SpoofTrackingDeviceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofTrackingDeviceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofTrackingDeviceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofTrackingDeviceResultData {
    return {};
  },

  toJSON(_: SpoofTrackingDeviceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofTrackingDeviceResultData>, I>>(base?: I): SpoofTrackingDeviceResultData {
    return SpoofTrackingDeviceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofTrackingDeviceResultData>, I>>(_: I): SpoofTrackingDeviceResultData {
    const message = createBaseSpoofTrackingDeviceResultData();
    return message;
  },
};

function createBaseSpoofTrackingDeviceActionStateData(): SpoofTrackingDeviceActionStateData {
  return {};
}

export const SpoofTrackingDeviceActionStateData = {
  encode(_: SpoofTrackingDeviceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofTrackingDeviceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofTrackingDeviceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofTrackingDeviceActionStateData {
    return {};
  },

  toJSON(_: SpoofTrackingDeviceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofTrackingDeviceActionStateData>, I>>(
    base?: I,
  ): SpoofTrackingDeviceActionStateData {
    return SpoofTrackingDeviceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofTrackingDeviceActionStateData>, I>>(
    _: I,
  ): SpoofTrackingDeviceActionStateData {
    const message = createBaseSpoofTrackingDeviceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
